import {
  vitalMetrics,
} from 'core/vitals/utils';
import {
  VitalFieldKey,
  VitalEditorFieldConfig,
  VitalMask,
} from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/Vitals/types';

const integerMask = (min: number, max: number) => ([
  { mask: '' },
  {
    mask: Number,
    min,
    max,
    scale: 0,
    normalizeZeros: true,
    radix: '.',
  },
]);

const decimalMask = (min: number, max: number, scale: number) => ([
  { mask: '' },
  {
    mask: Number,
    min,
    max,
    scale,
    padFractionalZeros: false,
    normalizeZeros: true,
    radix: '.',
    mapToRadix: ['.'],
  },
]);

// Use broad bounds unless the domain defines a range.
const editorMasks: Record<VitalFieldKey, VitalMask> = {
  systolicBloodPressureMmhg: integerMask(1, 999),
  diastolicBloodPressureMmhg: integerMask(1, 999),
  heartRateBpm: integerMask(1, 999),
  respiratoryRateBreathsPerMinute: integerMask(1, 999),
  temperatureFahrenheit: decimalMask(0, 999.9, 1),
  oxygenSaturationPercent: integerMask(0, 100),
};

const vitalsConfig: VitalEditorFieldConfig[] = vitalMetrics.map((metric) => ({
  ...metric,
  // Use the full label in the visit-note side panel without changing chart labels.
  viewLabel: metric.id === 'blood-pressure' ? metric.title : metric.viewLabel,
  fields: metric.series.map((field) => ({ ...field, mask: editorMasks[field.key] })),
  separator: metric.id === 'blood-pressure' ? '/' : undefined,
}));

export default vitalsConfig;
